import React from 'react';
import { connect } from 'react-redux';
import { DangerText } from 'scy/text';
import { track } from 'shared/models/analytic';
import { apply as applyPromo } from './actions';
import Input from 'scy/Input';
import { LoadingButton } from 'scy/buttons';
import { flex, flexShrink0 } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';

class PromoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.linkPromo || ''
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.applyCode = this.applyCode.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onInputChange(e) {
    this.setState({ value: e.target.value });
  }

  applyCode(event) {
    event.preventDefault();
    const promoCode = this.state.value;
    const orderId = this.props.orderId;
    track('Coupon Entered', {
      order_id: orderId,
      coupon: promoCode
    });
    return this.props.applyPromo(promoCode).then(action => {
      const error = this.props.error;
      if (error) {
        track('Coupon Denied', {
          order_id: orderId,
          coupon: promoCode,
          reason: error
        });
      } else {
        if (this._isMounted) this.setState({ value: '' });
        if (this.props.onSuccess) {
          this.props.onSuccess(action.promo || action.credit);
        }
      }
    });
  }

  render() {
    const { placeholder, loading, isDisabled, ariaLabel } = this.props;
    const error = this.props.errorMessage || this.props.error;

    return (
      <div className={this.props.className}>
        <form
          onSubmit={this.applyCode}
          className={`${flex} ${margin.bottom_sm}`}
        >
          <Input
            ariaLabel={ariaLabel}
            type="text"
            placeholder={placeholder}
            defaultValue={this.state.value}
            onChange={this.onInputChange}
            className={margin.right_sm}
          />
          <LoadingButton
            type="submit"
            disabled={isDisabled || this.state.value === ''}
            loading={loading}
            className={flexShrink0}
          >
            Apply
          </LoadingButton>
        </form>
        {!!error && (
          <DangerText className={margin.bottom_sm}>{error}</DangerText>
        )}
      </div>
    );
  }
}

const ConnectedPromoForm = connect(
  state => ({
    error: state.promo.error,
    loading: state.promo.loading,
    linkPromo: state.link.promo
  }),
  { applyPromo }
)(PromoForm);

export default ConnectedPromoForm;
